import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const LOAD_TIME_RATE_REQUEST = 'LOAD_TIME_RATE_REQUEST';
export const LOAD_TIME_RATE_SUCCESS = 'LOAD_TIME_RATE_SUCCESS';
export const LOAD_TIME_RATE_FAIL = 'LOAD_TIME_RATE_FAIL';

export const CREATE_TIME_RATE_REQUEST = 'CREATE_TIME_RATE_REQUEST';
export const CREATE_TIME_RATE_SUCCESS = 'CREATE_TIME_RATE_SUCCESS';
export const CREATE_TIME_RATE_FAIL = 'CREATE_TIME_RATE_FAIL';

export const UPDATE_TIME_RATE_REQUEST = 'UPDATE_TIME_RATE_REQUEST';
export const UPDATE_TIME_RATE_SUCCESS = 'UPDATE_TIME_RATE_SUCCESS';
export const UPDATE_TIME_RATE_FAIL = 'UPDATE_TIME_RATE_FAIL';

export const DELETE_TIME_RATE_REQUEST = 'DELETE_TIME_RATE_REQUEST';
export const DELETE_TIME_RATE_SUCCESS = 'DELETE_TIME_RATE_SUCCESS';
export const DELETE_TIME_RATE_FAIL = 'DELETE_TIME_RATE_FAIL';

export const LOAD_TIME_RATE_SYSTEM_REQUEST = 'LOAD_TIME_RATE_SYSTEM_REQUEST';
export const LOAD_TIME_RATE_SYSTEM_SUCCESS = 'LOAD_TIME_RATE_SYSTEM_SUCCESS';
export const LOAD_TIME_RATE_SYSTEM_FAIL = 'LOAD_TIME_RATE_SYSTEM_FAIL';


const loadTimeRateSuccess = (timeRateSystem) => ({ type: LOAD_TIME_RATE_SUCCESS, timeRateSystem });
const loadTimeRateRequest = () => ({ type: LOAD_TIME_RATE_REQUEST });
const loadTimeRateFail = (error) => ({ type: LOAD_TIME_RATE_FAIL, error });

const createTimeRateSuccess = (timeRateSystem) => ({ type: CREATE_TIME_RATE_SUCCESS, timeRateSystem });
const createTimeRateRequest = () => ({ type: CREATE_TIME_RATE_REQUEST });
const createTimeRateFail = (error) => ({ type: CREATE_TIME_RATE_FAIL, error });

const updateTimeRateSuccess = (timeRateSystem) => ({ type: UPDATE_TIME_RATE_SUCCESS, timeRateSystem });
const updateTimeRateRequest = () => ({ type: UPDATE_TIME_RATE_REQUEST });
const updateTimeRateFail = (error) => ({ type: UPDATE_TIME_RATE_FAIL, error });

const deleteTimeRateSuccess = (timeRateSystem) => ({ type: DELETE_TIME_RATE_SUCCESS, timeRateSystem });
const deleteTimeRateRequest = () => ({ type: DELETE_TIME_RATE_REQUEST });
const deleteTimeRateFail = (error) => ({ type: DELETE_TIME_RATE_FAIL, error });

const loadTimeRateSystemsRequest = () => ({ type: LOAD_TIME_RATE_SYSTEM_REQUEST });
const loadTimeRateSystemsSuccess = (payload) => ({ type: LOAD_TIME_RATE_SYSTEM_SUCCESS, payload });
const loadTimeRateSystemsFail = (error) => ({ type: LOAD_TIME_RATE_SYSTEM_FAIL, error });

export const getTimeRateSystems = () => (dispatch) => {
  dispatch(loadTimeRateSystemsRequest());
  return communicate({ url: 'TimeRateSystems' })
    .then((response) => dispatch(loadTimeRateSystemsSuccess(response.data.Data)))
    .catch((error) => {
      dispatch(loadTimeRateSystemsFail(error));
      toastrError(error);
    });
};

export const loadTimeRate = ({ userId }) => (dispatch) => {
  dispatch(loadTimeRateRequest());
  return communicate({
    url: 'TimeRateAssociations',
    method: 'get',
    getParams: Utils.objects.getQueryStringFromObject({
      valueIds: userId,
      AssociationTypeId: 'user'
    })
  }).then((response) => {
    dispatch(loadTimeRateSuccess(response.data.Data[0] || {}));
  }).catch((err) => {
    dispatch(loadTimeRateFail(err));
    toastrError(err);
  });
};

export const createTimeRate = (payload) => (dispatch) => {
  dispatch(createTimeRateRequest());
  return communicate({ url: 'TimeRateAssociations', method: 'post', data: payload })
    .then((response) => {
      dispatch(createTimeRateSuccess(response.data.Data));
      toastrSuccess(response);
    }).catch((err) => {
      dispatch(createTimeRateFail(err));
      toastrError(err);
    });
};

export const updateTimeRate = (payload) => (dispatch) => {
  dispatch(updateTimeRateRequest());
  return communicate({ url: 'TimeRateAssociations', method: 'put', data: payload })
    .then((response) => {
      dispatch(updateTimeRateSuccess(response.data.Data));
      toastrSuccess(response);
    }).catch((err) => {
      console.log(err);
      dispatch(updateTimeRateFail(err));
      toastrError(err);
    });
};

export const deleteTimeRate = (timeRateId) => (dispatch) => {
  dispatch(deleteTimeRateRequest());
  return communicate({ url: 'TimeRateAssociations', method: 'delete', getParams: `?id=${timeRateId}` })
    .then((response) => {
      dispatch(deleteTimeRateSuccess({}));
      toastrSuccess(response);
    }).catch((err) => {
      console.log(err);
      dispatch(deleteTimeRateFail(err));
      toastrError(err);
    });
};
